import { useState } from "react";

export function ComposerThumb({ src, fileName }: { src: string; fileName: string }) {
  const [errored, setErrored] = useState(false);
  if (errored) {
    return (
      <span
        className="grid h-7 w-7 place-items-center rounded-sm border border-line bg-paper-2 text-[7px] font-medium uppercase leading-none text-ink-3"
        title="Anteprima non disponibile"
        aria-label="Anteprima non disponibile"
      >
        N/D
      </span>
    );
  }
  return (
    <img
      src={src}
      alt={fileName}
      loading="lazy"
      decoding="async"
      onError={() => setErrored(true)}
      className="h-7 w-7 rounded-sm border border-line object-cover"
    />
  );
}
